import { render, staticRenderFns } from "./HowToUseSection.vue?vue&type=template&id=899ac6a2&scoped=true&"
import script from "./HowToUseSection.vue?vue&type=script&lang=js&"
export * from "./HowToUseSection.vue?vue&type=script&lang=js&"
import style0 from "./HowToUseSection.vue?vue&type=style&index=0&id=899ac6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ac6a2",
  null
  
)

export default component.exports